import { useState, useEffect } from 'react';
import './FooterPop.scss';
import icoCloseLayerPopup01 from 'assets/Mobile/images/common/ico_close_layerpopup01.png';
import Slide from './Slide';
import { complateData } from './data';

const FooterPop = props => {
  const [dataCurrent, setDataCurrent] = useState(complateData[0]);
  // const [selectedPlace, setSelectedPlace] = useState('공사중인 사업지');

  // useEffect(() => {
  //   if (dataCurrent.id === 'ing11' || dataCurrent.id === 'ing22') {
  //     setSelectedPlace('공사중인 사업지');
  //   } else {
  //     setSelectedPlace('준공 사업지');
  //   }
  // }, [dataCurrent]);

  const getDataCurrent = data => {
    setDataCurrent(data);
  };

  return (
    <div className={`footer-pop open`}>
      <div className="over-hidden">
        <div className="footer-wrapper">
          <div className="btn-close" onClick={() => props.setShow(false)}>
            <img src={icoCloseLayerPopup01} alt="" />
          </div>
          <div className="footer-content">
            <div className="footer-container">
              <header>
                <div className="header-left">
                  <h3>Digital Empire</h3>
                  <p>분양정보</p>
                </div>
              </header>
              <div className="footer-body">
                <div className="footer-body-img">
                  <div className="footer-body-img-left">
                    <img src={dataCurrent.imgLarge} alt={dataCurrent.name} />
                  </div>
                  <div className="footer-body-img-right">
                    <div className="footer-body-img-right-content">
                      <p className="sub-title">준공 사업지</p>
                      <h3 className="name">{dataCurrent.name}</h3>
                      <p className="desc"> {dataCurrent.desc}</p>
                      <p className="place">
                        대지 위치 : <span>{dataCurrent.place}</span>{' '}
                      </p>
                      <p className="phone">
                        분양 문의 : <span>{dataCurrent.phone} </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="footer-info">
                <div className="footer-info-list">
                  <div className="item">
                    <div className="th">공사기간</div>
                    <div className="acreage">{dataCurrent.period}</div>
                    <div className="scale">규모</div>
                    <div className="desc">{dataCurrent.place}</div>
                  </div>
                  <div className="item">
                    <div className="th">건축면적</div>
                    <div className="acreage">{dataCurrent.bArea}</div>
                    <div className="scale"></div>
                    <div className="desc"></div>
                  </div>
                  <div className="item">
                    <div className="th">연면적</div>
                    <div className="acreage">{dataCurrent.gArea}</div>
                    <div className="scale"></div>
                    <div className="desc"></div>
                  </div>
                  <div className="item">
                    <div className="th">용적율</div>
                    <div className="acreage">{dataCurrent.floorRatio}</div>
                    <div className="scale"></div>
                    <div className="desc"></div>
                  </div>
                </div>
              </div>
              <div className="footer-slide">
                {/* <Slide dataCurrent={dataCurrent} title={'공사중인 사업지'} getDataCurrent={getDataCurrent} listSlide={ingData} /> */}
                <Slide dataCurrent={dataCurrent} title={'준공 사업지'} getDataCurrent={getDataCurrent} listSlide={complateData} />
              </div>
              <div className="footer-footer">
                <button className="btn-submit" onClick={() => props.setShow(false)}>
                  확인
                </button>
                <p className="contact">
                  <span>고객컨텍센터 </span>080-535-3000
                </p>

                <p className="copy-right">COPYLIGHT ALL RIGHT RESERVED.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterPop;
